import clsx from "clsx";

import Button from "~/components/buttons/Button/Button";
import ButtonNewItem from "~/components/buttons/ButtonNewItem/ButtonNewItem";
import Tooltip from "~/components/Tooltip";
import { noTrackingDayReason } from "~/modules/timeTracking/utils/noTrackingDayReason.ts";

type Props = {
	date: Date;
	canAddTracking: boolean;
	openCreate: (date: Date) => void;
	className?: string;
	// A filled "+ Neuer Eintrag" instead of the dashed "+".
	primary?: boolean;
	// A label next to the "+" of the dashed button.
	label?: string;
};

/** The "+" of a day. A disabled "+" shows why the day takes no tracking. */
export function AddTimeTrackingButton(props: Props) {
	const { date, canAddTracking, openCreate, className, primary, label } = props;
	const buttonProps = { size: "sm", rounded: "full", theme: label ? "inline" : undefined } as const;

	if (primary) {
		const button = (
			<Button theme="primary"
					fullWidth
					disabled={!canAddTracking}
					// `Button` styles `disabled` only, so the keyboard needs its own guard.
					aria-disabled={!canAddTracking}
					tabIndex={canAddTracking ? undefined : -1}
					onClick={() => canAddTracking && openCreate(date)}>
				+ Neuer Eintrag
			</Button>
		);
		return (
			<div className={clsx("w-full", className)}>
				{canAddTracking ? button : (
					<Tooltip text={noTrackingDayReason}
							 className="whitespace-pre-line">
						<div className="w-full">{button}</div>
					</Tooltip>
				)}
			</div>
		);
	}

	if (canAddTracking) {
		return (
			<div className={clsx("flex grow", className)}>
				<ButtonNewItem {...buttonProps}
							   onClick={() => openCreate(date)}>{label}</ButtonNewItem>
			</div>
		);
	}

	return (
		<Tooltip text={noTrackingDayReason}
				 className="whitespace-pre-line">
			<div className={clsx("flex grow", className)}>
				<ButtonNewItem {...buttonProps}
							   disabled
							   onClick={() => openCreate(date)}>{label}</ButtonNewItem>
			</div>
		</Tooltip>
	);
}
